<template>
  <div class="wrapper">
    <section id="wrapper">
      <div class="title">Player vidéo universel EMPREINTE.COM</div>
      <demo class="md-transparent" :type="getType"></demo>

      <div class="inner">
        <div class="highlights">
          <section v-for="item in items">
            <div class="content" :class="{ 'selected-card': type===item.name }">
              <header>
                <div class="item-name">{{ describeItem(item.name) }}</div>
              </header>
              <div class="item-btns">
                <button
                  class="button button-small button-sec"
                  :ref="item.name"
                  @click="showIntegrateModal(item)"
                >
                  Intégrer
                </button>
                <button
                  class="button button-small"
                  :ref="item.name"
                  @click="changeType(item.name)"
                >
                  Visualiser
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
    <div class="integrate-modal" v-if="showModal && itemToHandle">
      <div class="modal-wrapper">
        <div class="modal-header">
          <button class="btnClose" @click="closeIntegrateModal()">x</button>
        </div>

        <div class="modal-container">
          <div class="embed-container">
            <div class="embed-title">Code Embed</div>
            <div class="embed-code">
              <textarea
                rows="6"
                id="text-to-copy"
                v-html="getCodeEmbed(this.iframeSource)"
              ></textarea>
              <button
                class="button button-small"
                :class="{ 'button-sec': copied }"
                @click="copyToClipboard()"
              >
                {{ copied ? "Copié" : "Copier" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Demo from "@/components/Demo";

export default {
  name: "highlight",
  data() {
    return {
      menu: menu,
      items: [],
      type: "Sous-titres",
      showModal: false,
      itemToHandle: null,
      iframeSource: "",
      copied: false,
    };
  },
  components: { Demo },

  methods: {
    getListDemo() {
      this.items = this.menu[this.$route.name].item;
    },
    getCodeEmbed(s) {
      return `<iframe src="${s}" width="100%" height="100%" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen" webkitallowfullscreen="true" mozallowfullscreen="true" frameborder="0"></iframe>`;
    },
    changeType(t) {
      this.type = t;
    },
    showIntegrateModal(t) {
      this.copied = false;

      switch (t.name) {
        case "Sous-titres":
          this.iframeSource =
            "https://app.empreinte.tv/embed/empreinte-motion-3jggmqze-67_340_150054cMp";
          break;
        case "navigation":
          this.iframeSource =
            "https://app.empreinte.tv/embed/BigBuckBunnyNXGJH";
          break;

        case "interactivity":
          this.iframeSource =
            "https://app.empreinte.tv/embed/frenchpolynesiamattdevir-l8bsb9dj-12qkiC7?plugin=interactivity&skin=dark";
          break;

        default:
          this.iframeSource = "";
      }
      this.itemToHandle = t;
      this.showModal = true;
    },
    closeIntegrateModal() {
      this.copied = false;
      this.itemToHandle = null;

      this.showModal = false;
    },
    async copyToClipboard() {
      try {
        this.copied = true;
        await navigator.clipboard.writeText(
          `<iframe src="${this.iframeSource}" width="100%" height="100%" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen" webkitallowfullscreen="true" mozallowfullscreen="true" frameborder="0"></iframe>`
        );
      } catch (err) {
        console.error("Failed to copy text: ", err);
      }
    },
    describeItem(n) {
      switch (n) {
        case "Sous-titres":
          return "Vidéo simple avec sous-titres";
        case "navigation":
          return "Vidéo enrichie avec indexation de média et chapitres ";
        case "interactivity":
          return "Vidéo interactive avec zone cachée cliquable, quiz, question, commentaires";
        default:
          return "";
      }
    },
  },
  created() {
    this.items = this.menu[this.$route.name].item;
    eventHub.$on("getListDemo", this.getListDemo);
  },
  computed: {
    getType() {
      switch (this.type) {
        case "Sous-titres":
          this.iframeSource =
            "https://app.empreinte.tv/embed/empreinte-motion-3jggmqze-67_340_150054cMp";
          return "CAPTION_OPTIONS";
        case "navigation":
          this.iframeSource =
            "https://app.empreinte.tv/embed/BigBuckBunnyNXGJH";

          return "NAVIGATION_OPTIONS";
        case "interactivity":
          this.iframeSource =
            "https://app.empreinte.tv/embed/frenchpolynesiamattdevir-l8bsb9dj-12qkiC7?plugin=interactivity&skin=dark";

          return "INTERACTIVITY_OPTIONS";
        default:
          return "CAPTION_OPTIONS";
      }
    },
  },
};
</script>
<style scoped>
.selected-card{
  background:#698792 ;
}
textarea:focus {
  border-color: #0a2239 !important;
  box-shadow: 0 0 0 1px #0a2239 !important;
}
.embed-title {
  font-weight: 600;
}
.embed-code {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.button-sec {
  background-color: #dde2e2 !important;
  box-shadow: inset 0 0 0 1px #555555;
  color: #000 !important;
}
.modal-container {
  height: 100%;
  padding: 2em;
}
.modal-wrapper {
  border: 1px solid #0a2239;
  position: absolute;
  z-index: 1000;
  top: 0;
  left: 0;
  height: fit-content;
  width: 50%;
  background: white;
  padding: 0px;
  bottom: 0;
  right: 0;
  margin: auto;
}
.video-js.vjs-classic-skin .modal-wrapper {
  background: rgba(43, 51, 63, 0.9);
}

.modal-wrapper .modal-header {
  border: none;
  display: flex;
  float: right;
}

.modal-wrapper .modal-header .btnClose {
  margin-left: auto;
}
.modal-wrapper .body {
  padding-top: 1.25em;
}
.btnClose {
  border: unset;
  background-color: transparent !important;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

@media screen and (max-width: 992px) {
  .modal-wrapper {
    position: fixed;
    z-index: 51;
  }

  .modal-wrapper .modal-header .btnClose {
    margin-top: 5% !important;
  }
}

@media screen and (max-width: 600px) {
  .modal-wrapper {
    width: 100%;
  }
  .modal-wrapper .modal-header .btnClose {
    margin-top: 0 !important;
  }
  .modal-wrapper .body {
    font-size: 3vw;
  }
}
</style>


// WEBPACK FOOTER //
// Highlights.vue?3e7ab1d6